export default __webpack_public_path__ + "static/media/logo-ae-conceptstore.3c6aca92.svg";